const addAriaAttribute = () => {
 const OPTION_REMOVE_COPIED_TITLE = true;

 const DATA_REMOVED_TITLE = `feui-removed-title`;

 const SELECTOR_LABEL_TARGET = `:is(button, input, textarea, select, [role="button"])[title]:not([aria-label])`;

 const applyAriaLabel = () => {
 const elements = document.querySelectorAll(SELECTOR_LABEL_TARGET);

 elements.forEach((el) => {
 if (!el.title.trim()) return;

 el.setAttribute(`aria-label`, el.title);

 if (OPTION_REMOVE_COPIED_TITLE) {
 el.setAttribute(
 `data-${DATA_REMOVED_TITLE}`,
 el.getAttribute(`title`),
 );
 el.removeAttribute(`title`);
 }
 });
 };

 const initialize = () => {
 applyAriaLabel();
 };

 initialize();

 addAriaAttribute.update = applyAriaLabel;

 // addAriaAttribute.cleanup = () => {};
};

export default addAriaAttribute;
